import { CHOOSE_Q_TYPE } from './actions/types';

export default {
  HOME: '/',
  MAP: {
    path: '/map/:id',
    thunk: (dispatch, getState) => {
      const { payload } = getState().location;
      const action = {
        type: CHOOSE_Q_TYPE,
        id: payload.id,
      };
      dispatch(action);
    },
  },
  CHOOSE: {
    path: '/:id',
    thunk: (dispatch, getState) => {
      const { payload: { id } } = getState().location;
      // console.dir(id);
      dispatch({ type: 'MAP', payload: { id } });
    },
  },
  RESULTS: {
    path: '/results',
    thunk: (dispatch) => {
      dispatch({ type: 'FINISHED' });
    },
  },
};



// WEBPACK FOOTER //
// ./src/routesMap.js